module.exports = "images/france-4.213f230a.png";